import React from "react";
import { Icon, IconProps } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { Boundary } from "../Boundary";
import { useObservationContext } from "../../data/observations/useObservationContext";

interface ObservationFormCategoryIconProps extends Omit<IconProps, "name"> {
    categoryId: number;
}

const ObservationFormCategoryIconContent: React.FC<ObservationFormCategoryIconProps> = ({ categoryId, ...iconProps }) => {
    const { data: { categories } } = useObservationContext();
    const { t } = useTranslation();

    const cetegory = categories.find(({ id }) => id === categoryId);

    if (!cetegory) {
        console.warn(t("Tuntematon kategoriatunniste"));
        return null;
    };

    if (!cetegory.icon) {
        return null;
    }

    return <Icon name={cetegory.icon} {...iconProps} />;
}

export const ObservationFormCategoryIcon: React.FC<ObservationFormCategoryIconProps> = (props) => {
    return (
        <Boundary fallback={<div> ? </div>}>
            <ObservationFormCategoryIconContent {...props} />
        </Boundary>
    )
}
